import { PrivateRoutes } from "./PrivateRoutes";

export const ApplicationRoutes = () => {
  return <PrivateRoutes />;
};
